module.exports = __webpack_public_path__ + "img/logo_grupotoky_atendimento.fcbee632.svg";